<template>
  <b-modal
    v-model="isOpen"
    title="IAdding a new Sales Manual"
    :width="500"
    @close="closeModal()"
  >
    <div class="service_replace_modal p-4">
      <h1 class="is-relative is-inline" style="width: fit-content">
        Adding a new Sales Manual
      </h1>

      <BaseSelect
        v-model="form.country"
        size="large"
        :list="countries"
        option-value="location_code"
        option-text="location_name"
        placeholder="Select a country"
        class="mb-4"
        label="Country (*)"
      />

      <BaseSelect
        v-model="form.sales_manual"
        size="large"
        :list="availableSalesManuals()"
        option-value="code"
        option-text="sales_manual_name"
        placeholder="Select a sales manual"
        class="mb-4"
        label="Sales Manual (*)"
      />

      <div v-if="0" class="d-flex">
        <div class="input_group mr-2">
          <label for="hotel_margin"><strong>Hotel Margin</strong></label>
          <b-form-input
            id="hotel_margin"
            v-model.number="form.hotel_margin"
            type="number"
            :min="0"
          />
        </div>

        <div class="input_group ml-2">
          <label for="service_margin"><strong>Service Margin</strong></label>
          <b-form-input
            id="service_margin"
            v-model.number="form.service_margin"
            type="number"
            :min="0"
          />
        </div>
      </div>

      <div class="is-flex is-justify-content-end mt-6">
        <BaseButton :loading="loading" action="principal" @click="onAddClick">
          <p slot="text">Add</p>
        </BaseButton>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import BaseSelect from "@/components/base-ui/BaseSelect.vue";
import BaseButton from "@/components/base-ui/BaseButton.vue";
import BaseInput from "@/components/base-ui/BaseTextarea.vue";
import BaseInputNumber from "@/components/base-ui/BaseInputNumber.vue";
import clientService from "@/services/client";

export default {
  name: "AddNewSalesManualModal",
  components: { BaseInputNumber, BaseInput, BaseButton, BaseSelect },
  props: {
    selectedContract: {
      type: Object,
      default: () => {},
    },
    isModalOpen: {
      type: Boolean,
      default: false,
    },
    closeModal: {
      type: Function,
      default: () => {},
    },
    loadClientContracts: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      isOpen: this.isModalOpen,
      serviceCode: "",
      form: {
        country: "",
        sales_manual: "",
        hotel_margin: 0,
        service_margin: 0,
      },
    };
  },
  computed: {
    ...mapGetters({
      itinerary: "itinerary/getItinerary",
      countries: "locations/listCountry",
      sales_manuals: "sales_manual/list",
    }),
  },
  watch: {
    isModalOpen(newValue) {
      this.isOpen = newValue;
    },
  },
  methods: {
    availableSalesManuals() {
      const currentSalesManuals = this.selectedContractSalesManuals();
      return this.sales_manuals
        .filter(
          (sm) => !currentSalesManuals.find((csm) => csm.code === sm.code)
        )
        .map((sm) => {
          return {
            ...sm,
            sales_manual_name: `${sm.code} (${sm.sales_manual_name})`,
          };
        });
    },
    selectedContractSalesManuals() {
      return this.selectedContract?.sales_manual_contract?.data || [];
    },
    async onAddClick() {
      this.loading = true;

      try {
        const { contract, client } = this.itinerary.data;
        const country = this.countries.find(
          (c) => c.location_code === this.form.country
        );

        const data = {
          id: contract.id,
          code: contract.code,
          name: contract.name,
          id_user: client.id,
          sales_manual_contract: [
            {
              id: null,
              code: this.form.sales_manual,
              location: [
                {
                  id: country.id,
                  code: country.location_code,
                  order: 1,
                },
              ],
              service_margin: this.form.service_margin,
              hotel_margin: this.form.hotel_margin,
            },
          ],
        };

        await clientService.saveContract(data);

        const key = `contracts__client__${client.id}`;

        localStorage.removeItem(key);

        await this.loadClientContracts(client.id, true);

        this.$buefy.toast.open({
          duration: 5000,
          message: "Sales manual added successfully!",
          position: "is-top",
          type: "is-success",
        });
      } catch (e) {
        this.$buefy.toast.open({
          duration: 5000,
          message: "There was an error in the process.",
          position: "is-top",
          type: "is-danger",
        });
      }

      this.loading = false;

      this.closeModal();
    },
  },
};
</script>
<style scoped>
.service_replace_modal {
  width: 100%;
}
.service_replace_modal h1 {
  font-size: 1.2rem;
  font-weight: 700;
  text-align: left;
  padding-top: 0.25rem;
  padding-bottom: 0.8rem;
  color: #000;
}
.service_replace_modal p,
.service_replace_modal span,
.service_replace_modal input {
  font-size: 0.8rem;
}
.service_replace_modal .input:focus {
  color: #363636 !important;
  border: none;
  box-shadow: none;
}
</style>
